/** URL-persisted filter defaults for the Schedule page (/schedule). */
export const SCHEDULE_FILTER_DEFAULTS = {
  search: '',
  // Priority is a multi-select stored as a comma-separated id list
  // so its "no filter" default is an empty string like `teams` — not 'all'.
  priority: '',
  category: 'all',
  teams: '',
  // Area is a multi-select stored as a comma-separated id list, like `teams`
  // and `priority` (SC-6251).
  area: '',
  // Unified day-count shared by the Calendar-grid and Map views (SC-6371) so a
  // day selection made in one view is retained when switching to the other.
  // Persisted in the URL like the other filters; omitted while at the default.
  // Gantt is excluded — its span is derived from a zoom level, not a day count.
  days: '3',
};
